export default "__VITE_ASSET__chuB0A7u__"